import { all } from 'redux-saga/effects'

import { jobSaga } from './job/saga'

export function* panelSaga() {
  yield all([jobSaga()])
}
